import axios from 'axios';
import { DELETE_CABLE_CONSTRUCTION_API_URL, DELETE_COUPLING_CONSTRUCTION_API_URL, DELETE_FOB_CONSTRUCTION_API_URL, DELETE_PONBOX_CONSTRUCTION_API_URL, UPDATE_ADAPTER_PIGTAIL_COUNT_FOB_CONSTRUCTION_API_URL, UPDATE_ADAPTER_PIGTAIL_COUNT_PON_BOX_CONSTRUCTION_API_URL, UPDATE_BOX_MODEL_CONSTRUCTION_API_URL, UPDATE_CABLE_CASSETTE_PATCH_CONSTRUCTOR_API_URL, UPDATE_CABLE_CONTRACTOR_CONSTRUCTOR_API_URL, UPDATE_CABLE_DESCRIPTION_CONSTRUCTOR_API_URL, UPDATE_CABLE_FORWARDING_CONSTRUCTOR_API_URL, UPDATE_CABLE_ID_CONSTRUCTOR_API_URL, UPDATE_CABLE_LENGTH_ACT_CONSTRUCTOR_API_URL, UPDATE_CABLE_STATUS_API_URL, UPDATE_COUPLING_API_URL, UPDATE_COUPLING_COORDINATE_CONSTRUCTOR_URL, UPDATE_COUPLING_COORDINATE_URL, UPDATE_COUPLING_DESCRIPTION_CONSTRUCTOR_API_URL, UPDATE_COUPLING_NAME_API_URL, UPDATE_COUPLING_NAME_CONSTRUCTOR_API_URL, UPDATE_COUPLING_RANK_API_URL, UPDATE_COUPLING_RANK_CONSTRUCTOR_API_URL, UPDATE_DIVIDER_2_MODEL_PONBOX_API_URL, UPDATE_DIVIDER_2_MODEL_PONBOX_CONSTRUCTION_API_URL, UPDATE_DIVIDER_MODEL_FOB_CONSTRUCTION_API_URL, UPDATE_DIVIDER_MODEL_PONBOX_API_URL, UPDATE_DIVIDER_MODEL_PONBOX_CONSTRUCTION_API_URL, UPDATE_FOB_API_URL, UPDATE_FOB_COORDINATE_CONSTRUCTION_URL, UPDATE_FOB_COORDINATE_URL, UPDATE_FOB_DESCRIPTION_CONSTRUCTION_API_URL, UPDATE_FOB_NAME_API_URL, UPDATE_FOB_NAME_CONSTRUCTION_API_URL, UPDATE_FOB_RANK_API_URL, UPDATE_FOB_RANK_CONSTRUCTION_API_URL, UPDATE_HIGHWAY_CONTRACTOR_CABLE_API_URL, UPDATE_HIGHWAY_LINE_API_URL, UPDATE_HIGHWAY_LINE_CABLE_API_URL, UPDATE_HIGHWAY_LINE_LENGTH_ACT_API_URL, UPDATE_HIGHWAY_TYPE_CABLE_API_URL, UPDATE_PON_BOX_API_URL, UPDATE_PON_BOX_NAME_API_URL, UPDATE_PONBOX_COORDINATE_CONSTRUCTION_URL, UPDATE_PONBOX_COORDINATE_URL, UPDATE_PONBOX_DESCRIPTION_CONSTRUCTION_API_URL, UPDATE_PONBOX_NAME_CONSTRUCTION_API_URL, UPDATE_PONBOX_NUMBER_BOX_API_URL, UPDATE_PONBOX_NUMBER_BOX_CONSTRUCTION_API_URL, UPDATE_RANK_CABLE_API_URL, UPDATE_RANK_CABLE_CONSTRUCTOR_API_URL, UPDATE_TYPE_CABLE_CONSTRUCTOR_API_URL, UPDATE_WELDIND_COUNT_COUPLING_CONSTRUCTION_API_URL } from '../../Optics/OpticApiConfig';
// import { UPDATE_WELL_API_URL, UPDATE_HIGHWAY_LINE_API_URL, UPDATE_PILLAR_API_URL, UPDATE_COUPLING_API_URL, UPDATE_FOB_API_URL,
//     UPDATE_HIGHWAY_LINE_CONTRACT_NUMBER_API_URL, UPDATE_HIGHWAY_LINE_LENGTH_ACT_API_URL, UPDATE_HIGHWAY_LINE_CABLE_API_URL, UPDATE_PON_BOX_API_URL,
//     UPDATE_COUPLING_NAME_API_URL, UPDATE_FOB_NAME_API_URL, UPDATE_PON_BOX_NAME_API_URL, UPDATE_COUPLING_RANK_API_URL,
//     UPDATE_FOB_RANK_API_URL, UPDATE_WELL_OWNER_API_URL, UPDATE_PILLAR_OWNER_API_URL, UPDATE_HIGHWAY_CONTRACTOR_CABLE_API_URL,
//     UPDATE_HIGHWAY_ENGINNER_CABLE_API_URL, UPDATE_HIGHWAY_LINE_CABLE_NUMBER_API_URL, UPDATE_WELL_COORDINATE_URL, 
//     UPDATE_PILLAR_COORDINATE_URL,
//     UPDATE_COUPLING_COORDINATE_URL,
//     UPDATE_FOB_COORDINATE_URL,
//     UPDATE_PONBOX_COORDINATE_URL,
//     UPDATE_HIGHWAY_TYPE_CABLE_API_URL,
//     UPDATE_AMPLIFIER_MODEL_API_URL,
//     UPDATE_OP_MODEL_API_URL,
//     UPDATE_PON_BOX_COMING_API_URL,
//     UPDATE_DIVIDER_MODEL_API_URL,
//     UPDATE_DIVIDER_DESCRIPTION_API_URL,
//     UPDATE_DIVIDER_MODEL_PONBOX_API_URL,
//     UPDATE_FOB_RANK_NODE_API_URL,
//     UPDATE_RANK_CABLE_API_URL,
//     UPDATE_CASSETTE_MODEL_API_URL,
//     UPDATE_CASSETTE_DESCRIPTION_API_URL,
//     UPDATE_DIVIDER_2_MODEL_PONBOX_API_URL,
//     UPDATE_PONBOX_NUMBER_BOX_API_URL} from '../OpticApiConfig';

// обновление Well
// export const UpdateWell = (id, textComment, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_WELL_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Well owner
// export const UpdateWellOwner= (id, ownerWellId, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_WELL_OWNER_API_URL}${id}`, { ownerWellId: ownerWellId, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Well coordinate map
// export const UpdateWellCoordinate= (id, latitude, longitude, user,  refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//        // showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_WELL_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//        // showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//       //  showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Pillar coordinate map
// export const UpdatePillarCoordinate= (id, latitude, longitude, user,  refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//        // showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_PILLAR_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//        // showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//       //  showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление CouplingConstruction coordinate map
export const UpdateCouplingCoordinateConstruction= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_COORDINATE_CONSTRUCTOR_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob coordinate map construction
export const UpdateFobCoordinateConstruction= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_COORDINATE_CONSTRUCTION_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление PonBox coordinate map
// export const UpdatePonBoxCoordinate= (id, latitude, longitude, user,  refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//        // showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_PONBOX_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//        // showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//       //  showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление HighwayLine
export const UpdateCableDescriptionConstruction = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_CABLE_DESCRIPTION_CONSTRUCTOR_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление HighwayLine ContractNumber
// export const UpdateHighwayLineContractNumber = (id, textContractNumber, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_HIGHWAY_LINE_CONTRACT_NUMBER_API_URL}${id}`, { contractNumber: textContractNumber, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление HighwayLine CableNumber
// export const UpdateHighwayLineCableNumber = (id, textCableNumber, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_HIGHWAY_LINE_CABLE_NUMBER_API_URL}${id}`, { cableNumber: textCableNumber, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление UpdateCableLengthActConstruction
export const UpdateCableLengthActConstruction= (id, lengthAct, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CABLE_LENGTH_ACT_CONSTRUCTOR_API_URL}${id}`, { lengthAct: lengthAct, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
       // refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLineCable Construct
export const UpdateCableConstruction= (id, CableId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CABLE_ID_CONSTRUCTOR_API_URL}${id}`, { cableId: CableId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        //refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Contractor Constrbction
export const UpdateContractorConstruction= (id, contractorId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CABLE_CONTRACTOR_CONSTRUCTOR_API_URL}${id}`, { contractorId: contractorId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
       // refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable CassettePatch Constrbction
export const UpdateCassettePatchConstruction= (id, selectedCassetteModel,cassetteCableCount, selectedPolishingPatch, patchCableCount, showSnackbar, authorId, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CABLE_CASSETTE_PATCH_CONSTRUCTOR_API_URL}${id}`, 
        { 
            cassetteModelId: selectedCassetteModel,
            cassetteCount: cassetteCableCount,
            polishingPatchId: selectedPolishingPatch,
            patchCount: patchCableCount,
            authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
       // refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Forwarding Constrbction
export const UpdateForwardingConstruction= (id, forwardingCount, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CABLE_FORWARDING_CONSTRUCTOR_API_URL}${id}`, { contractorId: forwardingCount, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Type
export const UpdateTypeCableConstruction= (id, typeId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_TYPE_CABLE_CONSTRUCTOR_API_URL}${id}`, { typeId: typeId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление Cable Rank Construct
export const UpdateRankCableConstrucyion= (id, rankId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_RANK_CABLE_CONSTRUCTOR_API_URL}${id}`, { typeId: rankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// удаления кабеля
export const DeleteCableConstruction = async (inputId, showSnackbar, refresh, close) => {
  const token = localStorage.getItem('token');

  if (!inputId) {
    showSnackbar('Пустой ID кабеля!', 'snackbarWarning');
    return;
  }

  if (!token) {
    showSnackbar('Ошибка! Токен не найден');
    return;
  }

  try {
    const response = await axios.delete(`${DELETE_CABLE_CONSTRUCTION_API_URL}?highwayLineId=${inputId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      showSnackbar('Кабель успешно удалён!', 'snackbarSuccess');
      refresh(); // если нужно обновить
      close();   // если нужно закрыть окно
    } else if (response.status === 404) {
      showSnackbar('Кабель с указанным ID не найден!', 'snackbarWarning');
    } else {
      showSnackbar('Ошибка сервера при удалении кабеля!', 'snackbarWarning');
    }
  } catch (error) {
    showSnackbar('Ошибка при отправке запроса: ' + error.message, 'snackbarWarning');
  }
};

// удаления Coupling
export const DeleteCouplingConstruction = async (inputId, showSnackbar, refresh, close) => {
  const token = localStorage.getItem('token');

  if (!inputId) {
    showSnackbar('Пустой ID муфты!', 'snackbarWarning');
    return;
  }

  if (!token) {
    showSnackbar('Ошибка! Токен не найден');
    return;
  }

  try {
    const response = await axios.delete(`${DELETE_COUPLING_CONSTRUCTION_API_URL}?couplingId=${inputId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      showSnackbar('Муфта успешно удалена!', 'snackbarSuccess');
      refresh(); // если нужно обновить
      close();   // если нужно закрыть окно
    } else if (response.status === 404) {
      showSnackbar('Муфта с указанным ID не найдена!', 'snackbarWarning');
    } else {
      showSnackbar('Ошибка сервера при удалении муфты!', 'snackbarWarning');
    }
  } catch (error) {
    showSnackbar('Ошибка при отправке запроса: ' + error.message, 'snackbarWarning');
  }
};

// удаления FOB
export const DeleteFobConstruction = async (inputId, showSnackbar, refresh, close) => {
  const token = localStorage.getItem('token');

  if (!inputId) {
    showSnackbar('Пустой ID fob!', 'snackbarWarning');
    return;
  }

  if (!token) {
    showSnackbar('Ошибка! Токен не найден');
    return;
  }

  try {
    const response = await axios.delete(`${DELETE_FOB_CONSTRUCTION_API_URL}?fobId=${inputId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      showSnackbar('fob успешно удалена!', 'snackbarSuccess');
      refresh(); // если нужно обновить
      close();   // если нужно закрыть окно
    } else if (response.status === 404) {
      showSnackbar('fob с указанным ID не найдена!', 'snackbarWarning');
    } else {
      showSnackbar('Ошибка сервера при удалении fob!', 'snackbarWarning');
    }
  } catch (error) {
    showSnackbar('Ошибка при отправке запроса: ' + error.message, 'snackbarWarning');
  }
};

// удаления PonBox
export const DeletePonBoxConstruction = async (inputId, showSnackbar, refresh, close) => {
  const token = localStorage.getItem('token');

  if (!inputId) {
    showSnackbar('Пустой ID PonBox!', 'snackbarWarning');
    return;
  }

  if (!token) {
    showSnackbar('Ошибка! Токен не найден');
    return;
  }

  try {
    const response = await axios.delete(`${DELETE_PONBOX_CONSTRUCTION_API_URL}?ponBoxId=${inputId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      showSnackbar('PonBox успешно удалена!', 'snackbarSuccess');
      refresh(); // если нужно обновить
      close();   // если нужно закрыть окно
    } else if (response.status === 404) {
      showSnackbar('PonBox с указанным ID не найдена!', 'snackbarWarning');
    } else {
      showSnackbar('Ошибка сервера при удалении PonBox!', 'snackbarWarning');
    }
  } catch (error) {
    showSnackbar('Ошибка при отправке запроса: ' + error.message, 'snackbarWarning');
  }
};

   
    
  

// // обновление Cable Engineer
// export const UpdateHighwayLineEngineer= (id, textEngineer, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_HIGHWAY_ENGINNER_CABLE_API_URL}${id}`, { engineer: textEngineer, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Pillar
// export const UpdatePillar = (id, textComment, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_PILLAR_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Pillar owner
// export const UpdatePillarOwner= (id, ownerPillarId, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_PILLAR_OWNER_API_URL}${id}`, { ownerPillarId: ownerPillarId, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление Coupling coment
export const UpdateCouplingDescriptionConstruction = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_COUPLING_DESCRIPTION_CONSTRUCTOR_API_URL}${id}`, { comment: textComment, authorId: authorId },{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling name
export const UpdateCouplingNameConstruction= (id, couplingId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_NAME_CONSTRUCTOR_API_URL}${id}`, { couplingId: couplingId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling rank
export const UpdateCouplingRankConstruction= (id, couplingRankId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_RANK_CONSTRUCTOR_API_URL}${id}`, { rankComponentId: couplingRankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob comment
export const UpdateFobDescriptionConstruction = (id, textComment, showSnackbar, authorId) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_FOB_DESCRIPTION_CONSTRUCTION_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob name construction
export const UpdateFobNameConstruction= (id, fobId, showSnackbar, authorId, cantonFobRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_NAME_CONSTRUCTION_API_URL}${id}`, { fobId: fobId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonFobRefresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление BOX name construction
export const UpdateBoxModelConstruction= (id, boxId, showSnackbar, authorId, cantonFobRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_BOX_MODEL_CONSTRUCTION_API_URL}${id}`, { fobId: boxId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonFobRefresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление Fob rank construction
export const UpdateFobRankConstruction= (id, fobRankId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_RANK_CONSTRUCTION_API_URL}${id}`, { rankComponentId: fobRankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление Fob rank NODE
// export const UpdateFobRankNode= (id, fobRankId, showSnackbar, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_FOB_RANK_NODE_API_URL}${id}`, { rankComponentId: fobRankId}, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление Pon-box description
export const UpdatePonBoxDescriptionConstruction = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_PONBOX_DESCRIPTION_CONSTRUCTION_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление ПОН-БОКС name constr
export const UpdatePonBoxNameConstruction= (id, ponBoxId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PONBOX_NAME_CONSTRUCTION_API_URL}${id}`, { ponBoxId: ponBoxId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление PonBox Coming
// export const UpdatePonBoxComing= (id, comingId, showSnackbar, authorId, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_PON_BOX_COMING_API_URL}${id}`, { ponBoxId: comingId, authorId: authorId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };


// // обновление Amplifier model
// export const UpdateAmplifierModel= (id, amplifierId, showSnackbar, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_AMPLIFIER_MODEL_API_URL}${id}`, { modelId: amplifierId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление OP model
// export const UpdateOpModel= (id, opId, showSnackbar, refresh) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_OP_MODEL_API_URL}${id}`, { modelId: opId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         refresh();
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Divider model NODE
// export const UpdateDividerModel= (id, dividerId, showSnackbar) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_DIVIDER_MODEL_API_URL}${id}`, { modelId: dividerId }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// обновление Divider №1 model PonBox
export const UpdateDividerModelPonBoxConstruction= (id, dividerId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_MODEL_PONBOX_CONSTRUCTION_API_URL}${id}`, { ponBoxId: dividerId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider №2 model PonBox
export const UpdateDivider2ModelPonBoxConstruction= (id, dividerId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_2_MODEL_PONBOX_CONSTRUCTION_API_URL}${id}`, { ponBoxId: dividerId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider №1 model Fob
export const UpdateDividerModelFobConstruction= (id, dividerId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_MODEL_FOB_CONSTRUCTION_API_URL}${id}`, { ponBoxId: dividerId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Pigtail\Adapter Fob
export const UpdatePigtailAdapterConstruction= (id, pigtailCount, adapterCount, polishingId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_ADAPTER_PIGTAIL_COUNT_FOB_CONSTRUCTION_API_URL}${id}`, 
        { 
            pigtailCount: pigtailCount,
            adapterCount: adapterCount,
            polishingId: polishingId,
            authorId: authorId,     
        }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Welding COUPLING
export const UpdateWeldingCouplingConstruction= (id, weldingCount, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_WELDIND_COUNT_COUPLING_CONSTRUCTION_API_URL}${id}`, 
        { 
            polishingId: weldingCount,
            authorId: authorId,     
        }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Pigtail\Adapter PonBox
export const UpdatePigtailAdapterPonBoxConstruction= (id, pigtailCount, adapterCount, polishingId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_ADAPTER_PIGTAIL_COUNT_PON_BOX_CONSTRUCTION_API_URL}${id}`, 
        { 
            pigtailCount: pigtailCount,
            adapterCount: adapterCount,
            polishingId: polishingId,
            authorId: authorId,     
        }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// // обновление Divider description
// export const UpdateDividerDescription = (id, textComment, showSnackbar) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_DIVIDER_DESCRIPTION_API_URL}${id}`, { comment: textComment, authorId: 'null' }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Cassette model
// export const UpdateCassetteModel= (id, cassetteId, showSnackbar) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
    
//     axios.patch(`${UPDATE_CASSETTE_MODEL_API_URL}${id}`, { modelId: cassetteId}, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         console.log(error)
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };

// // обновление Cassette description
// export const UpdateCassetteDescription = (id, textComment, showSnackbar) => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         showSnackbar('Ошибка! Токен не найден');
//         return;
//     }
//     axios.patch(`${UPDATE_CASSETTE_DESCRIPTION_API_URL}${id}`, { comment: textComment, authorId: 'null' }, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}` 
//         }
//     })
//     .then(response => {
//         showSnackbar('Данные успешно обновлены');
//     })
//     .catch(error => {
//         showSnackbar('Ошибка! Данные не обновлены');
//     });
// };


// обновление PonBox numberBox
export const UpdateNumberPonBoxConstructor= (id, textNumberBox, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PONBOX_NUMBER_BOX_CONSTRUCTION_API_URL}${id}`, { engineer: textNumberBox, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление PonBox coordinate construction
export const UpdatePonBoxCoordinateConstruction= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PONBOX_COORDINATE_CONSTRUCTION_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};


